import { useStrings } from "@1js/localization-components";
import { Text, makeStyles } from "@fluentui/react-components";
import * as React from "react";
import { PropertyContext } from "../../pages/PropertyContext.web";
import {
  ManageAccessLogin,
  ManageAccessNoSharedPrompts,
} from "./ManageSharedPrompts.strings";

const useStyles = makeStyles({
  content: {
    display: "flex",
    paddingBottom: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "40px",
    alignSelf: "stretch",
    "@media (max-width: 540px)": {
      gap: "8px",
      alignItems: "center",
    },
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
  },
  titleAndBody: {
    display: "flex",
    width: "350px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    "@media (max-width: 540px)": {
      width: "272px",
    },
  },
  text: {
    textAlign: "center",
    fontFamily: "Segoe UI",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "20px",
  },
  image: {
    display: "flex",
    width: "128px",
    height: "128px",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url('/images/no-shared-prompts.webp')`,
  },
});

export const NoSharedPrompts: React.FC = () => {
  const styles = useStyles();
  const strings = useStrings({
    ManageAccessNoSharedPrompts,
    ManageAccessLogin,
  });
  const [siteSetting] = React.useContext(PropertyContext);

  return (
    <div className={styles.content}>
      <div className={styles.wrapper}>
        <div className={styles.titleAndBody}>
          <div className={styles.image} />
          <Text className={styles.text}>
            {siteSetting.user
              ? strings.ManageAccessNoSharedPrompts()
              : strings.ManageAccessLogin()}
          </Text>
        </div>
      </div>
    </div>
  );
};
